


document.addEventListener("DOMContentLoaded", function() {
        
     function removeFromCart(...variantIds) {
        if (variantIds.length === 0) {
          console.warn('No variant IDs provided for removal. Nothing to do.');
          return Promise.resolve(true); 
        }
      
        const updates = {};
        variantIds.forEach(id => {
          if (typeof id === 'number' && id > 0) { 
            updates[id] = 0; 
          } else {
            console.warn(`Invalid variant ID provided: ${id}. Skipping.`);
          }
        });
      
        if (Object.keys(updates).length === 0) {
          console.warn('No valid variant IDs to remove after filtering. Nothing to do.');
          return Promise.resolve(true); 
        }
      
        // KS 13 Sep 2026: the section id was hard-coded from an older theme, so the drawer never
        // refreshed after a removal. Resolve it from the DOM, fall back to the old constant.
        var drawerEl = document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]');
        var sectionId = drawerEl ? drawerEl.id.replace('shopify-section-', '') : 'sections--25562165805401__cart-drawer';

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: sectionId
          })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().catch(() => ({ message: response.statusText })) // Fallback if JSON parsing fails
              .then(errorData => {
                throw new Error(`Failed to remove items: ${errorData.message || 'Unknown error'}`);
              });
          }
          // If response is OK, proceed to the next .then()
          return response.json(); // Or just return response if you don't need the parsed JSON
        })
        .then(data => {

          
          var countEl = document.querySelector("cart-count");
          if (countEl) countEl.innerText = data.item_count;
          const txt = data.sections ? data.sections[sectionId] : null;
          var targetElement = document.getElementById('cart-drawer');
          if (txt && targetElement) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(txt,'text/html');
            const fresh = doc.getElementById('cart-drawer');
            if (fresh) targetElement.innerHTML = fresh.innerHTML;
          }
          return true; // Indicate success
        })
        .catch(error => {
          console.error('Error removing items:', error);
          return false; // Indicate failure
        });
      }
    
    document.addEventListener("cart:change", function(event) {

              const product1ID = Number(document.querySelector('#product1')?.getAttribute('data-id'));
              const product2ID = Number(document.querySelector('#product2')?.getAttribute('data-id'));
              const freeGift1 = Number(document.querySelector('#free-gift1')?.getAttribute('data-free-gift1'));
              const freeGift2 = Number(document.querySelector('#free-gift2')?.getAttribute('data-free-gift2'));
              let product1InCart = false;
              let product2InCart = false;
              const inCart = { product1VarId: null, product2VarId: null };
        
              
              let cart = event.detail["cart"];
              let total_price = cart.total_price;
        
              cart.items.forEach((item)=>{
                if( item.product_id === product1ID){
                  product1InCart = true;
                  inCart.product1VarId = item.variant_id;
                }
                if( item.product_id === product2ID){
                  product2InCart = true;
                  inCart.product2VarId = item.variant_id;
                }
              });
      

      
              if( total_price < freeGift1 && product1InCart && product2InCart && inCart.product1VarId && inCart.product2VarId ){
                 
                   removeFromCart(inCart.product1VarId, inCart.product2VarId) // Assuming inCart is defined elsewhere
                      .then(success => {
                        if (success) {
                              console.log('remove first free gift success');
                              console.log('remvove second free gift success');
                              product1InCart = false;
                              product2InCart = false;
                        } else {
                              console.log('remove first free gift failed');
                              console.log('remvove second free gift failed');
                        }
                      })
                      .catch(error => {
                        // This catch block will only be hit if there's an unhandled error
                        // within the .then() chain itself, not from the fetch operation
                        console.error('An unexpected error occurred during removal process:', error);
                      });
                  
                  
              }
              else if( total_price < freeGift1 && product1InCart && inCart.product1VarId){
              //   alert('remove first item condition');
              //   alert('product1incart ' +product1InCart );
              // alert('product2incart ' +product2InCart );
              //  alert('product1varId ' +inCart.product1VarId )
              //  alert('product2varId ' +inCart.product2VarId );
              // alert('total '+total_price);
              // alert('freegift1 '+freeGift1);
              //   alert('freegift2 '+freeGift2);
                removeFromCart(inCart.product1VarId) // Assuming inCart is defined elsewhere
                  .then(success => {
                    if (success) {
                      console.log('remove first free gift success');
                       product1InCart = false;
                    } else {
                      console.log('remove first free gift failed');
                    }
                  })
                  .catch(error => {
                    console.error('An unexpected error occurred during removal process:', error);
                  });
                
               
              }
              else if( total_price < freeGift1 && product2InCart && inCart.product2VarId){
              //     alert('remove second item condition');
              //   alert('product1incart ' +product1InCart );
              // alert('product2incart ' +product2InCart );
              //  alert('product1varId ' +inCart.product1VarId )
              //  alert('product2varId ' +inCart.product2VarId );
              // alert('total '+total_price);
              // alert('freegift1 '+freeGift1);
              //   alert('freegift2 '+freeGift2);
                removeFromCart(inCart.product2VarId) // Assuming inCart is defined elsewhere
                    .then(success => {
                      if (success) {
                              console.log('remvove second free gift success');
                          product2InCart = false;
                      } else {
                       console.log('remvove second free gift failed');
                      }
                    })
                    .catch(error => {
                      console.error('An unexpected error occurred during removal process:', error);
                    });
               
                
              }
              else if( total_price < freeGift2 && total_price > freeGift1 && product2InCart && inCart.product2VarId){
              //   alert('remove second item condition');
              //   alert('product1incart ' +product1InCart );
              // alert('product2incart ' +product2InCart );
              //  alert('product1varId ' +inCart.product1VarId )
              //  alert('product2varId ' +inCart.product2VarId );
              // alert('total '+total_price);
              // alert('freegift1 '+freeGift1);
              //   alert('freegift2 '+freeGift2);
                removeFromCart(inCart.product2VarId) // Assuming inCart is defined elsewhere
                  .then(success => {
                    if (success) {
                      console.log('remvove second free gift success');
                      product2InCart = false;
                    } else {
                      console.log('remvove second free gift failed');
                    }
                  })
                  .catch(error => {
                    console.error('An unexpected error occurred during removal process:', error);
                  });
                
              }
              
          });
});



(function () {
  var KS_GIFT_IDS = [0, 0]
    .filter(function (id) { return id > 0; });
  if (!KS_GIFT_IDS.length) return;

  function ksDrawerSectionId() {
    var el = document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  function ksApplyUpdates(updates) {
    var sectionId = ksDrawerSectionId();
    var body = { updates: updates };
    if (sectionId) body.sections = sectionId;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var count = document.querySelector('cart-count');
        if (count) count.innerText = data.item_count;
        var target = document.getElementById('cart-drawer');
        var html = sectionId && data.sections ? data.sections[sectionId] : null;
        if (target && html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('cart-drawer');
          if (fresh) target.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function (e) { console.warn('[ks-gift] update failed', e); });
  }

  var ksBusyUntil = 0;

  function ksCapGifts(cart) {
    try {
      if (!cart || !cart.items || Date.now() < ksBusyUntil) return;
      var updates = {};
      var changed = false;
      KS_GIFT_IDS.forEach(function (pid) {
        var lines = cart.items.filter(function (i) { return i.product_id === pid; });
        if (!lines.length) return;
        lines.forEach(function (line, idx) {
          var want = idx === 0 ? 1 : 0;              // keep one unit of the first line, drop the rest
          if (line.quantity !== want) { updates[line.key || line.variant_id] = want; changed = true; }
        });
      });
      if (!changed) return;
      ksBusyUntil = Date.now() + 2500;               // stop this from chasing its own cart:change
      console.log('[ks-gift] capping duplicate free gifts', updates);
      ksApplyUpdates(updates);
    } catch (e) { console.warn('[ks-gift] guard error', e); }
  }

  document.addEventListener('cart:change', function (ev) {
    ksCapGifts(ev && ev.detail ? ev.detail.cart : null);
  });

  // A cart duplicated before this patch shipped (or edited on /cart) never fires cart:change on its own.
  // The gift line's quantity input is the one that carries .none-c, on both the drawer and the cart page,
  // so its presence is a free signal that this cart holds a gift and is worth auditing once.
  function ksAuditOnLoad() {
    try {
      if (!document.querySelector('input.quantity-input.none-c')) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) ksCapGifts(cart); })
        .catch(function () {});
    } catch (e) { /* never block the page */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ksAuditOnLoad);
  } else {
    ksAuditOnLoad();
  }

  // Block a second submit of the same gift form inside the add round-trip.
  var ksLastGiftSubmit = 0;
  document.addEventListener('submit', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest('.product-add') : null;
    if (!wrap) return;
    var now = Date.now();
    if (now - ksLastGiftSubmit < 3000) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
    ksLastGiftSubmit = now;
    var btn = wrap.querySelector('.add_button');
    if (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.style.pointerEvents = 'none';
      setTimeout(function () { btn.removeAttribute('aria-disabled'); btn.style.pointerEvents = ''; }, 3000);
    }
  }, true);
})();
